<script>
import { OrderProcessItemQcServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const opisp = new OrderProcessItemQcServiceProxy()
const columns = [
  {
    title: 'page_bussiness_data_quality_name_of_quality',
    dataIndex: 'itemName',
    key: 'itemName'
  },
  {
    title: 'page_job_plan_standard_value',
    dataIndex: 'standardValue',
    key: 'standardValue'
  },
  {
    title: 'page_job_plan_measured_value',
    dataIndex: 'measuredValue',
    key: 'measuredValue',
    scopedSlots: { customRender: 'measuredValue' }
  }
]
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 14 }
      },
      data: [],
      confirmLoading: false
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible && this.item.id) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      this.data = [
        {
          itemName: this.item.itemName,
          standardValue: this.item.standardValue,
          measuredValue: this.item.measuredValue
        }
      ]
    },
    handleChange(value, key) {
      const newData = [...this.data]
      const target = newData.find((item) => key === item.id)
      if (target) {
        target['measuredValue'] = Number(value).toFixed(2)
        this.data = newData
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    save() {
      const body = {
        id: this.item.id,
        measuredValue: this.data[0].measuredValue
      }
      opisp.updateQcItem(body).then(() => {
        this.$message.success(this.$t('page_mdc_setting_edit_success'))
        this.$emit('save')
      })
    }
  }
}
</script>

<template>
  <a-modal
    :width="800"
    :title="$t('page_job_plan_add_quality')"
    :visible="visible"
    @cancel="cancel()"
    @ok="save()"
    :confirm-loading="confirmLoading"
  >
    <a-form-model :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
      <a-row>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_process_name')">
            {{ item.processName }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_Process_coding')">
            {{ item.processCode }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_order_no')">
            {{ item.orderCode }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_product_name')">
            {{ item.productName }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_plan_process_persoal')">
            {{ item.producerName }}
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('page_job_plan_workstation_work')">
            {{ item.workStationName }}
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <ml-table :columns="columns" :data-source="data">
      <template slot="measuredValue" slot-scope="text, record">
        <a-input-number
          :value="text"
          :step="0.01"
          @change="(value) => handleChange(value, record.id)"
        />
      </template>
    </ml-table>
  </a-modal>
</template>

<style scoped>
.ant-form-item-control {
  line-height: 39px !important;
}
</style>
